import React, { useEffect, useState, useLayoutEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactNotification from 'react-notifications-component';
import _ from 'lodash';
import { createGlobalStyle } from 'styled-components';
import SmartBanner from 'react-smartbanner';

// CSS
import 'animate.css';
import 'react-datepicker/dist/react-datepicker.css';
import 'react-lazy-load-image-component/src/effects/blur.css';
import 'react-notifications-component/dist/theme.css';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-smartbanner/dist/main.css';
/**
 * These two has the min.css links for respective min css file.
 * Previously used CDNs are now being used as npm.
 * import '../assets/css/min-css-styles/font-awesome.min.css';
 * import '../assets/css/min-css-styles/animate.min.css';
 */
import '../assets/css/structure.scss';
import '../assets/css/styles.css';
import '../assets/css/custom.css';
import '../assets/css/gamification.css';
import reset from '../constants/css/reset';
const GlobalStyle = createGlobalStyle`${reset}`;

// constants
import Loader from '../components/Common/Loader';
import LocalStrings from '../assets/languages';
import { getOS, setSmartBanners, useInterval } from '../util/util-common';
import { ALLOWED_FEATURE_KEYS } from '../constants/section-constants/common-constants';
import { INTERVAL_10, INTERVAL_5 } from '../constants/constant';

// actions
import {
  checkEvent,
  checkToken,
  setDeviceSize,
  showSidebar,
  detectInternetConnection
} from '../actions';

// components
import AdminLayout from '.';
import FourZeroFour from '../components/Common/pagenotfound';

const MainApp = props => {
  const {
    session,
    isLoggedIn,
    deviceSize,
    internetLost,
    eventDetails,
    profileToggleReducer
  } = props;

  const location = useLocation();
  const [isEventLoad, setEventLoad] = useState('');
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const hostname = window.location.hostname;
    const seocode = hostname.split(`.${session.site_url}`)[0];

    if (isLoggedIn && !_.isEmpty(session?.sessionToken)) {
      props.checkToken(session, res => {
        if (res.success) {
          handleCheckEvent();
        }
      });
    } else {
      handleCheckEvent();
    }

    function handleCheckEvent() {
      props.checkEvent(session, seocode, res => {
        if (res.success) {
          setEventLoad('loadedcorrect');
        } else {
          setEventLoad('loadedwrong');
        }
      });
    }
  }, []);

  useEffect(() => {
    if (!_.isEmpty(eventDetails) && !showBanner) {
      setSmartBanners(eventDetails);
      setTimeout(() => {
        checkMetaTag();
      }, INTERVAL_5);
    }
  }, [eventDetails]);

  useLayoutEffect(() => {
    window.addEventListener('resize', updateSize);
    updateSize();
    return () => window.removeEventListener('resize', updateSize);
  }, []);

  useInterval(() => {
    if (internetLost) props.detectInternetConnection(session);
  }, INTERVAL_10 * 3);

  const updateSize = () => {
    let localDeviceSize = {
      width: window.innerWidth,
      height: window.innerHeight,
      isMobile: false,
      isTab: false
    };

    if (screen.width <= 576) localDeviceSize.isMobile = true;
    if (screen.width > 576 && screen.width <= 991) {
      localDeviceSize.isMobile = false;
      localDeviceSize.isTab = true;
    }

    props.setDeviceSize(localDeviceSize);

    if (window.innerWidth > 991 || screen.width > 991) {
      props.showSidebar(false);
    }
  };

  const checkMetaTag = () => {
    let smartTag = document.querySelector(`meta[name="apple-itunes-app"]`);
    if (smartTag) {
      setShowBanner(true);
    }
  };

  return (
    <>
      <div
        className="container"
        style={
          profileToggleReducer?.show ||
          (!isLoggedIn &&
            location.pathname === `/${ALLOWED_FEATURE_KEYS.overview}`) ||
          _.isEmpty(eventDetails)
            ? { maxWidth: '100vw', padding: 0 }
            : {}
        }
      >
        {showBanner && deviceSize.isMobile ? (
          <SmartBanner
            force={getOS()}
            position="bottom"
            title={eventDetails?.eventname}
            storeText={{
              ios: LocalStrings.dynamic.kGetTheIOSBanner,
              android: LocalStrings.dynamic.kGetTheAndroidBanner
            }}
            price={{ ios: '', android: '' }}
          />
        ) : (
          ''
        )}

        <Switch>
          {isEventLoad === 'loadedwrong' ? (
            <FourZeroFour unpublishedEvent />
          ) : isEventLoad != '' ? (
            <Route
              path="/"
              // render={props => <LazyAdminLayout {...props} />
              render={props => (
                <AdminLayout
                  {...props}
                  incorrectEvent={
                    isEventLoad == 'loadedcorrect' &&
                    session &&
                    session.eventid &&
                    session.eventid != ''
                      ? false
                      : true
                  }
                />
              )}
            />
          ) : (
            <Loader />
          )}
        </Switch>
      </div>

      <ReactNotification />
    </>
  );
};

const mapStateToProps = state => {
  return {
    session: state.session,
    isLoggedIn: state.isLoggedIn,
    deviceSize: state.deviceSize,
    internetLost: state.internetLost,
    eventDetails: state.eventDetails,
    profileToggleReducer: state.profileToggleReducer
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      checkEvent,
      checkToken,
      setDeviceSize,
      showSidebar,
      detectInternetConnection
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MainApp);
